import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance2,
} from "App/constants";
import {
  InputTextArea,
  InputTextMaster,
  MasterButton,
  Modal,
} from "App/Component/ui";
import { Grid } from "@material-ui/core";
import { useState } from "react";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
  titleModal,
} from "App/utils/helpers";
import { LIST_URL_MASTER } from "utils/masters";

export const RESET_STATE_RUANG_APLICARES = {
  id: "",
  name: "",
  kode: "",
  remark: "",
};

export const urlGet = LIST_URL_MASTER.ruang_aplicares.list;
export const urlAdd = LIST_URL_MASTER.ruang_aplicares.add;
export const urlUpdate = LIST_URL_MASTER.ruang_aplicares.update;
export const urlDelete = LIST_URL_MASTER.ruang_aplicares.delete;

export const deleteRuangAplicareById = async (id) => {
  try {
    await instance2.post(
      urlDelete,
      {},
      {
        headers: {
          idruang_aplicares: id,
        },
      }
    );
    return {
      state: true,
      message: "Berhasil menghapus data",
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    sort: false,
    align: "center",
  },
  {
    id: "kode",
    disablePadding: false,
    label: "KODE",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "kode_sirsonline",
    disablePadding: false,
    label: "KODE SIRS OL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const ModalForm = ({
  setShowModal,
  formData,
  setFormData,
  setNewData,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const add = async () => {
    return instance2.post(urlAdd, {
      ...formData,
    });
  };

  const update = () => {
    return instance2.post(
      urlUpdate,
      {
        ...formData,
      },
      {
        headers: {
          idruang_aplicares: formData.id,
        },
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (formData.name === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama tidak boleh kosong");
    } else {
      try {
        if (formData.id === "") {
          await add();
          defaultToastSuccess("Berhasil menambah data");
        } else if (formData.id !== "") {
          await update();
          defaultToastSuccess("Berhasil mengubah data");
        }
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setFormData(RESET_STATE_RUANG_APLICARES);
        setShowModal(false);
        setNewData();
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <Modal
      title={`${titleModal(formData.id)} Ruang Aplicare`}
      show={setShowModal}>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type='hidden'
            name='id'
            id='id'
            readOnly={true}
            value={formData.id}
          />
          <Grid item sm={12}>
            <InputTextMaster
              name='kode'
              label='KODE'
              id='kode'
              readOnly={isNull(formData.id) ? false : true}
              disabled={isNull(formData.id) ? false : true}
              value={formData.kode}
              onChange={handleChange("kode")}
              placeholder='Kode'
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='name'
              label='NAMA'
              id='name'
              value={formData.name}
              onChange={handleChange("name")}
              placeholder='Nama'
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextArea
              label={"Catatan"}
              placeholder={"Catatan"}
              name='remark'
              value={formData.remark}
              onChange={handleChange("remark")}
              id='remark'
              rows={"3"}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};
